/*
 * ============================================================
 * SAV_ERP — Smart Account Vision Enterprise Resource Planning
 * Copyright (c) 2026 Hatem Mohamed Abdalla.
 * All rights reserved.
 *
 * This file is part of a proprietary software product owned
 * solely by Hatem Mohamed Abdalla (UAE, +971 50 390 9781).
 * Copying, redistribution, modification, reverse engineering
 * or reuse in any form without prior written consent of the
 * copyright owner is strictly prohibited and will be
 * prosecuted under UAE Federal Law No. 38/2021 on Copyright
 * and applicable international treaties.
 *
 * Fingerprint: SAV-ERP-HMA-2026-#a7f3d0
 * ============================================================
 */
const quietPatterns = [
  /Download the React DevTools/i,
  /Performance Metrics/i,
  /webpackHotDevClient/i,
];

const shouldQuietConsole = () => {
  if (process.env.REACT_APP_ENABLE_DEV_CONSOLE === 'true') return false;
  return true;
};

const shouldSuppress = (args) => {
  const text = args.map((item) => {
    if (typeof item === 'string') return item;
    try { return JSON.stringify(item); } catch (_err) { return String(item); }
  }).join(' ');
  return quietPatterns.some((pattern) => pattern.test(text));
};

export const installCustomerConsoleGuard = () => {
  if (typeof window === 'undefined' || !shouldQuietConsole()) return;
  if (window.__SAV_ERP_CUSTOMER_CONSOLE_GUARD__) return;
  window.__SAV_ERP_CUSTOMER_CONSOLE_GUARD__ = true;

  ['log', 'info', 'debug'].forEach((level) => {
    const original = console[level]?.bind(console);
    if (!original) return;
    console[level] = (...args) => {
      if (shouldSuppress(args)) return;
      if (process.env.REACT_APP_ENABLE_DEV_CONSOLE === 'true') original(...args);
    };
  });
};

installCustomerConsoleGuard();
